<template>
<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page header -->
	  <page-heading :show="true" pageTitle="HEADER-CATALOG" :pageTitle2="pages[0].section != null ? pages[0].section.topicName +' ('+pages[0].section.name+')' : ''"></page-heading>

		<div class="columns">

			<div class="col-main">

				<div class="columns is-multiline" style="background: #F5F5F5; margin: 0; padding:0;">

					<div class="column is-12" style="background: #fff;">

						<!-- PAGE INTRO? -->
						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="SITE_CATALOG_IS_TOPIC_INTRO" title="Handelt es sich bei dieser Doppelseite um ein Kapitelintro?"></label-name>
							</div>
							<div class="control">
								<b-switch v-model.sync="pages[0].isTopicIntro" type="primary" size="small"></b-switch>
								<!-- <toggle-button @change="siteCatalog.hasShipmentRecipientList = !siteCatalog.hasShipmentRecipientList" :sync="true" :value="siteCatalog.hasShipmentRecipientList" :labels="{checked: 'JA', unchecked: ''}"/> -->
							</div>
						</div>

						<!-- section -->
						<div class="control is-horizontal">

							<div class="control-label">
								<label-name labelKey="PAGE-SECTION"></label-name>
							</div>

							<div class="control">
								<span class="select is-medium">
									<select id="PAGE-SECTION" v-model="pages[0].section" :disabled="userRole=='Redaktion'">
										<option :value="null">{{ $t('SELECT_BOX-SECTION') }}</option>
										<option v-for="section in sections" :value="section">
											{{ section.topicName }} ( {{ section.name }})
										</option>
									</select>
								</span>
							</div>

						</div>

						<!-- DOUBLE PAGE MANUFACTURER? -->
						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="SITE_CATALOG_IS_MANUFACTURER_RIGHT_PAGE" title="Wurde die rechte Seite von einem anderen Hersteller gebucht?"></label-name>
							</div>
							<div class="control">
								<b-switch v-model="isRightPageManufacturer" type="primary" size="small"></b-switch>
								<!-- <toggle-button @change="siteCatalog.hasShipmentRecipientList = !siteCatalog.hasShipmentRecipientList" :sync="true" :value="siteCatalog.hasShipmentRecipientList" :labels="{checked: 'JA', unchecked: ''}"/> -->
							</div>
						</div>

					</div>
				</div>


				<div class="columns pageSettings">

					<div class="column is-6 left">

						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="PAGE_DESCRIPTION"></label-name>
							</div>
							<div class="control">
								<input id="PAGE_DESCRIPTION" :class="[{ 'is-disabled': userRole == 'Redaktion' }, 'input is-medium']" type="text" v-model="pages[0].name">
							</div>
						</div>


						<!-- status -->
						<div class="control is-horizontal">

							<div class="control-label">
								<label-name labelKey="PAGE-STATUS"></label-name>
							</div>

							<div class="control">
								<status-dropdown type="pageStatus" label="SELECT_BOX-STATUS_" :data.sync="pages[0].status"></status-dropdown>
							</div>

						</div>

						<!-- manufacturer -->
						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="PAGE-MANUFACTURER"></label-name>
							</div>
							<div class="control">
								<span class="select is-medium">
									<select id="PAGE-MANUFACTURER" v-model="pages[0].manufacturer" :disabled="userRole=='Redaktion'">
										<option :value="null">{{ $t('SELECT_BOX-MANUFACTURER') }}</option>
										<option v-for="manufacturer in manufacturers" :value="manufacturer.id">
											{{ manufacturer.name }}
										</option>
									</select>
								</span>
							</div>
						</div>


					</div>

					<div class="column is-6 right">

						<template v-if="isRightPageManufacturer">

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="PAGE_DESCRIPTION"></label-name>
								</div>
								<div class="control">
									<input id="PAGE_DESCRIPTION" :class="[{ 'is-disabled': userRole == 'Redaktion' }, 'input is-medium']" type="text" v-model="pages[1].name">
								</div>
							</div>

							<!-- status -->
							<div class="control is-horizontal">

								<div class="control-label">
									<label-name labelKey="PAGE-STATUS"></label-name>
								</div>

								<div class="control">
									<status-dropdown type="pageStatus" label="SELECT_BOX-STATUS_" :data.sync="pages[1].status"></status-dropdown>
								</div>

							</div>

							<!-- manufacturer -->
							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="PAGE-MANUFACTURER"></label-name>
								</div>
								<div class="control">
									<span class="select is-medium">
										<select id="PAGE-MANUFACTURER" v-model="pages[1].manufacturer" :disabled="userRole=='Redaktion'">
											<option :value="null">{{ $t('SELECT_BOX-MANUFACTURER') }}</option>
											<option v-for="manufacturer in manufacturers" :value="manufacturer.id">
												{{ manufacturer.name }}
											</option>
										</select>
									</span>
								</div>
							</div>

						</template>

					</div>

				</div>


				<div id="pagesWrapper">

					<div class="columns statusBar">

						<div :class="['column is-6 pageStatus', pages[0].status ? pages[0].status.name : '']"></div>
						<div :class="['column is-6 pageStatus', pages[1].status ? pages[1].status.name : '']"></div>

					</div>
					<!-- include pages -->
					<!-- @deleteElement="deleteElement" -->
					<double-page
						:pages.sync="pages"
						:pageLayoutChanged="{ 'left': pages[0].pageLayout, 'right': pages[1].pageLayout }"
						:isDetailed="true"
						viewType="detailed"
						@save="formSubmit">
					</double-page>

					<!-- pageOptions -->
					<div class="pageOptions columns" v-if="userRole != 'Redaktion'">
						<div class="column has-text-centered" v-for="i in 2">

							<div class="control multiselect">

								<multiselect
									v-model="pages[i-1].pageLayout"
									placeholder="Seitenlayout wählen"
									track-by="name"
									label="name"
									:allowEmpty="false"
									:custom-label="customPageLayoutLabel"
									:options="pageLayouts"
									:option-height="104"
									:show-labels="false"
									:searchable="false"
									:disabled="userRole=='Redaktion'"
									@select="changePageLayout(i)">

									<template slot="tag" slot-scope="props">
										<span class="option__icon icon is-small"><i :class="optionsGetIcon(props.option.name)"></i></span>
										<span class="option__title">{{ $t('SELECT_BOX-PAGE_LAYOUT_' + props.option.name) }}</span>
									</template>

									<template slot="option" slot-scope="props">
										<span class="option__icon icon is-small"><i :class="optionsGetIcon(props.option.name)"></i></span>
										<span class="option__title">{{ $t('SELECT_BOX-PAGE_LAYOUT_' + props.option.name) }}</span>
									</template>

							    </multiselect>

							</div>

						</div>
					</div>

				</div> <!-- // #pagesWrapper -->


				<div class="section variants" v-if="userRole == 'Administrator' || userRole == 'Redaktion'">

					<div class="title is-5 has-text-left"><lang labelKey="CATALOG_PAGE-HEADER-CATALOG_PAGE_VARIANTS"></lang></div>


					<div class="columns">

						<div :class="['column', isRightPageManufacturer ? 'is-6' : 'is-12' ]">

							<template v-if="pages[0] && pages[0].catalogPageVariants && pages[0].catalogPageVariants.length > 0">

								<div class="variant" v-for="(catalogPageVariant, index) in pages[0].catalogPageVariants" :key="catalogPageVariant.id">

									<lightbox class="variantImgWrapper" :src="getVariantPreviewURL(catalogPageVariant.preview)">
										<div class="lazyImg lazy-img-fadein" v-lazy:background-image="getVariantPreviewURL(catalogPageVariant.preview)"></div>
									</lightbox>

									<div :class="'variantStatus-'+(catalogPageVariant.status ? catalogPageVariant.status.name : catalogPageVariant.status = catalogPageVariantStatus.DEFAULT) + ' variantOptions is-clearfix'">

										<div class="variantStatusSelector is-pulled-left">
											<span class="select is-small">
                          <select v-model="catalogPageVariant.status" :class="{'is-disabled': isReadOnly}">
															<option v-for="variantStatus in catalogPageVariantStatus" :value="variantStatus">{{ $t('SELECT_BOX-CATALOG_PAGE-VARIANT_STATUS-' + variantStatus.name) }}</option>
                          </select>
                      </span>
										</div>

										<a :href="getVariantDownloadURL(catalogPageVariant.preview)" download class="button is-small is-pulled-right">
											<span class="icon is-small">
												<i class="icon-ak-download"></i>
											</span> Download
										</a>

									</div>

								</div>

							</template>

							<div v-else>

								<alert icon="info-circle">Es sind noch keine Varianten vorhanden ...</alert>

							</div>

						</div>


						<div class="column is-6" v-if="isRightPageManufacturer">

							<template v-if="pages[1] && pages[1].catalogPageVariants && pages[1].catalogPageVariants.length > 0">
								<div class="variant" v-for="(catalogPageVariant, index) in pages[1].catalogPageVariants" :key="catalogPageVariant.id">

									<lightbox class="variantImgWrapper" :src="getVariantPreviewURL(catalogPageVariant.preview)">
										<div class="lazyImg lazy-img-fadein" v-lazy:background-image="getVariantPreviewURL(catalogPageVariant.preview)"></div>
									</lightbox>

									<div :class="'variantStatus-'+(catalogPageVariant.status ? catalogPageVariant.status.name : catalogPageVariant.status = catalogPageVariantStatus.DEFAULT) + ' variantOptions is-clearfix'">

										<div class="variantStatusSelector is-pulled-left">
											<span class="select is-small">
                          <select v-model="catalogPageVariant.status" :class="{'is-disabled': isReadOnly}">
															<option v-for="variantStatus in catalogPageVariantStatus" :value="variantStatus">{{ $t('SELECT_BOX-CATALOG_PAGE-VARIANT_STATUS-' + variantStatus.name) }}</option>
                          </select>
                      </span>
										</div>

										<a :href="getVariantDownloadURL(catalogPageVariant.preview)" download class="button is-small is-pulled-right">
											<span class="icon is-small">
												<i class="icon-ak-download"></i>
											</span> Download
										</a>

									</div>

								</div>

							</template>

							<div v-else>

								<alert icon="info-circle">Es sind noch keine Varianten vorhanden ...</alert>

							</div>

						</div>

					</div>
				</div>


				<div class="section onlineCatalog" v-if="userRole=='Administrator'">

					<div class="title is-5 has-text-left"><lang labelKey="CATALOG_PAGE-HEADER-CATALOG_PAGE_ONLINE_CATALOG"></lang></div>

					<div class="columns">

						<div class="column is-6">
							<div class="heading">Online Katalog - Links</div>
							<crop-image uploadPreset='catalogPage_onlineCatalog' :page="pages[0]" @save="formSubmit"></crop-image>
						</div>

						<div class="column is-6">
							<template v-if="pages[1] && pages[1].catalogPageElements.some(pe => pe.contentElement && pe.contentElement.type && pe.contentElement.type.name == 'RICH_TEXT')">
								<div class="heading">Online Katalog - Rechts</div>
								<crop-image uploadPreset='catalogPage_onlineCatalog' :page="pages[1]" @save="formSubmit"></crop-image>
							</template>
						</div>


					</div>

				</div>


				<!-- COMMENTS -->
				<comments :threadID.sync="pages[0].thread" :api="'catalogPage/'+pages[0].id"></comments>

			</div> <!-- // col-main -->


	    <div class="col-aside">

				<affix :offset="50">

					<custom-button type="blue" icon="icon-ak-speichern" name="PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="formSubmit({ isSilent: false })"></custom-button>
          			<custom-button name="CATALOG-BTN-LAST_CHANGES" type="dark" icon="icon-ak-history" @click.native="goHistory" v-if="userRole == 'Administrator'"></custom-button>

					<div class="sidebox" v-if="userRole != 'Redaktion'">
						<div class="heading">Preview</div>
						<vue-dropzone
							ref="vueDropzonePreview"
							url="fileProcessing/upload?preset=catalogPage"
							:formDataAppend="[{ 'catalogPage': pages[0].id }]"
							:thumbnailWidth="145"
							:thumbnailHeight="67"
							:maxFiles="1"
							acceptedFiles=".pdf"
							:isClickable="true"
							dictDefaultMessage = "<i class='fa fa-cloud-upload'></i>PDF hochladen"
							v-on:vdropzone-mounted="dzPreviewInit"
							v-on:vdropzone-drop="dzPreviewDrop"
							v-on:vdropzone-success="dzPreviewSuccess"
							v-on:vdropzone-removed-file="dzPreviewRemoveFile"
							dzClass="dzSingle">
            			</vue-dropzone>

					</div>

				</affix>

      </div>

    </div>


	</template> <!-- // isLoading -->

</div>

</template>



<script>
import doublePage from './incl-doublePage';
import comments from '../utils/incl-comments';
import Multiselect from 'vue-multiselect';
import statusDropdown from '../utils/incl-statusDropdown'
import cropImage from '../utils/cropImage';
import vue2Dropzone from '../utils/dropzoneWrapper'

export default {

	name: 'page',

	components: {
		doublePage,
		comments,
		vueDropzone: vue2Dropzone,
		Multiselect,
		statusDropdown,
		cropImage
	},

	data() {
		return {
				pages: [],
				pageLayouts: [],
				manufacturers: [],
				sections: [],
				isNewPage: false,
				isLoading: true,
				isSaving: false,
				isRightPageManufacturer: false
      }
    },


	watch: {

		isRightPageManufacturer(newVal, oldVal) {
			// console.log(newVal, oldVal);
			if(newVal == false) {

				this.pages[1].manufacturer = null;
				this.pages[1].status = null;
				this.pages[1].name = null;

				/*
				if(this.pages[0].manufacturer != null) {
					this.pages[1].manufacturer = this.pages[0].manufacturer;
					this.pages[1].status = this.pages[0].status;
					this.pages[1].name = this.pages[0].name;
				}
				*/

			}
			else if(newVal == true) {

				if(this.pages[0].manufacturer != null && this.pages[0].manufacturer == this.pages[1].manufacturer) {
					this.pages[1].manufacturer = null;
					this.pages[1].status = null;
					this.pages[1].name = null;
				}
			}
		},


	},

	computed: {

		pageStatus() {
			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_STATUS');
		},

		catalogPageVariantStatus() {
			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_VARIANT_STATUS');
		},

		downloadURL() {
			var asset = this.$config.assets + this.pages[0].preview.path + '/' + this.pages[0].preview.filename;
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
		},

		isReadOnly() {

			return this.userRole == 'Redaktion';

		}

	},

	created() {

		// EXISTING PAGE
		if(this.$route.params.page1ID && Number.isInteger(parseInt(this.$route.params.page1ID)) &&
	 		this.$route.params.page2ID && Number.isInteger(parseInt(this.$route.params.page2ID)) )
		{
			this.fetchData();
		}

		// NEW PAGE
		else
		{

			this.fetchMandatoryFields();

			this.isNewPage = true;

      // fetch data
			this.axios.get(this.$config.api + 'catalogPage?filters[catalog.id]='+this.catalogId)
				.then(response => {

					var length = response.data.catalogPage.length;

					for(var i = 0; i < 2; i++)
					{
						this.pages.push({
							pageLayout: {
								id: 1,
								name: "COLS_1"
							},
							status: this.pageStatus.CREATED,
							catalogPageElements: [],
							catalogPageVariants: [],
							name: '',
							manufacturer: null,
							section: null,
							sortorder: length + i,
							catalog: this.catalogId
						});
					}

					this.isLoading = false;

        }).catch(function(error) {
            console.log('Error: ', error.message);
            this.isLoading = false;
        });

		}
	},

    mounted() {



    },


    methods: {

		goHistory() {
			this.$router.push({ name: 'catalogPageChangeLog'} );
		},

		customPageLayoutLabel (val) {

			return this.$t('SELECT_BOX-PAGE_LAYOUT_' + val.name);

	    },

		optionsGetIcon(name) {

			switch(name) {
				case 'COLS_1':
					return 'icon-ak-seitenschema1';
				case 'COLS_2_2TO1':
					return 'icon-ak-seitenschema21';
				case 'COLS_2_1TO2':
					return 'icon-ak-seitenschema12';
				case 'COLS_3':
					return 'icon-ak-seitenschema3';
			}

		},

		getVariantPreviewURL(preview) {

			return this.$config.assets + preview.path + '/' + preview.filename;

		},

		getVariantDownloadURL(preview) {

			return this.$config.assets + preview.path + '/' + preview.filename.substr(0, preview.filename.lastIndexOf(".")) + ".pdf";

		},

		changePageLayout(page) {

			// do db update
			if(!this.isNewPage) {

				this.formSubmit({ isSilent: false });

			}

		},


		// dropzone preview handling
		// ---------------------------------------------------------------------------
		dzPreviewInit() {

			if(this.pages[0].catalogPageVariants.length > 0 && this.pages[0].catalogPageVariants[0].preview) {

				let url = this.getVariantPreviewURL(this.pages[0].catalogPageVariants[0].preview);
				let mockFile = { id: 'previewImage', name: this.pages[0].catalogPageVariants[0].preview.filename, type: "image/*", size: 123 };

				this.$refs.vueDropzonePreview.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzPreviewDrop() {

            this.$refs.vueDropzonePreview.$children[0].removeAllFiles();

        },

		dzPreviewSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.pages[0].preview = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			this.fetchData();

			/*
			this.axios.get(this.$config.api + 'catalogPageVariant?include=catalogPageVariant.asset,catalogPageVariant.preview,catalogPageVariant.status&filters[catalogPage]='+this.pages[0].id)
				.then((res) => {

					console.log("result: ", res.data);
					this.pages[0].catalogPageVariants = res.data.catalogPageVariant;

					this.$refs.vueDropzonePreview.$children[0].removeAllFiles()
					this.dzPreviewInit();

					// save
					this.formSubmit( { isSilent: true } );

				}).catch((error) => {
					console.log('Error: ', error.message);
					this.isLoading = false;
				});
				*/

		},

		dzPreviewRemoveFile(file, error, xhr) {

			if(typeof file === 'undefined') {
				return;
			}

			// remove previewImage
			if(file.id == 'previewImage') {

				// remove properties
				this.pages[0].catalogPageVariants = null;
				this.pages[1].catalogPageVariants = null;

				this.pages[0].preview = null;
				this.pages[1].preview = null;

				this.formSubmit({isSilent: false});

			}

		},

		formSubmit(options=null) {

			if(options==null) {
				{
					true
				}
			}

			if(options.isSilent == false) {
				this.isSaving = true;
			}

			this.pages[1].section = this.pages[0].section;
			this.pages[1].catalog = this.pages[0].catalog = this.catalogId; // assign current catalog_id
			this.pages[1].isTopicIntro = this.pages[0].isTopicIntro;
			this.pages[1].thread = this.pages[0].thread;

			// this.pages[1].name = this.pages[0].name;
			// this.pages[1].manufacturer = this.pages[0].manufacturer;
			// this.pages[1].status = this.pages[0].status;
			/*
			this.pages[1].onlineCatalogImage = this.pages[0].onlineCatalogImage;
			this.pages[1].onlineCatalogHeader = this.pages[0].onlineCatalogHeader;
			this.pages[1].onlineCatalogTeaser = this.pages[0].onlineCatalogTeaser;
			*/
			var savePages = [this.pages[0], this.pages[1]];

			var self = this;

			this.axios.put(this.$config.api + 'catalogPage', savePages)
				.then(function(response) {

					if(options.isSilent == false) {
						self.$notify.success({content: self.$t("MSG-SUCCESS-DATA_SAVE")});
					}

					// if we're creating a new double page, assign the new page ids
					if(self.isNewPage) {
						for(var i=0; i < 2; i++) {
							self.pages[i].id = response.data.catalogPage[i].id;
						}
						self.$router.replace( { name: 'catalogPage', params: { 'page1ID': self.pages[0].id, 'page2ID': self.pages[1].id } });
					}

					self.isSaving = false;

				}).catch(function(error) {
					console.log('Error: ', error.message);
					self.isSaving = false;
				});

		},


		fetchMandatoryFields() {

			var self = this;

			// get pageLayouts
			function getPageLayouts() {
				return self.axios.get(self.$config.api + 'catalogPageLayout');
			}

			// get manufacturers
			function getManufacturers() {
				return self.axios.get(self.$config.api + 'manufacturer?orderBy=name');
			}

			// get sections
			function getSections() {
				return self.axios.get(self.$config.api + 'catalog?include=catalog.catalogSections&filters[id]='+self.catalogId+'&orderBy=catalogSection.sortorder');
			}

			// make the request
			this.axios.all([getPageLayouts(), getManufacturers(), getSections()])

				.then(self.axios.spread(function (pageLayouts, manufacturers, sections) {

					self.pageLayouts = pageLayouts.data.catalogPageLayout;
					self.manufacturers = manufacturers.data.manufacturer;
					self.sections = sections.data.catalog[0].catalogSections;

				})).catch(function(error) {
					console.log('Error: ', error.message);
				});

		},


		fetchData() {

			this.isLoading = true;

      // fetch data
			this.axios.get(this.$config.api + 'catalogPage?filters[catalog.id]='+this.catalogId+'&filters[id]='+this.$route.params.page1ID+','+this.$route.params.page2ID+'&include=catalogPage.onlineCatalogImage,catalogPage.pageLayout,contentElement.contentElementData,catalogPage.catalogPageElements,catalogPage.status,catalogPageElement.status,catalogPage.section,catalogPageElement.contentElement,contentElement.type,contentElementData.product,product.productVariants,productVariant.voucher,product.productVouchers,productVoucher.productVoucherProductVariants,product.productAssets,productAsset.asset,contentElementData.assets,contentElementDataAsset.asset,catalogPage.preview,catalogPage.catalogPageVariants,catalogPageVariant.status,catalogPageVariant.preview&orderBycatalogPageVariant.sortorder&orderBy=catalogPageElements.sortorder')

				.then(response => {

					this.fetchMandatoryFields();

					// make sure that pages have a pageLayout and a status set
					for(var i=0; i < response.data.catalogPage.length; i++)
					{
						if(response.data.catalogPage[i].pageLayout == null) {
							response.data.catalogPage[i].pageLayout = 1;
						}
						if(response.data.catalogPage[i].status == null) {
							response.data.catalogPage[i].status = this.pageStatus.CREATED;
						}
					}

					// console.log("response: ", response.data.catalogPage);

					this.isRightPageManufacturer = response.data.catalogPage[1].manufacturer != null && response.data.catalogPage[0].manufacturer != response.data.catalogPage[1].manufacturer
          this.pages = response.data.catalogPage;

					this.isLoading = false;

        }).catch(function(error) {
            console.log('Error: ', error.message);
            this.isLoading = false;
        });

		},


    }

}

</script>


<style lang="scss" scoped>

  @import '../../assets/css/variables.scss';

	#pagesWrapper {

		.statusBar {

			.pageStatus {

				padding: 0;
				border-top: 10px solid transparent;

				&.CREATED {
					border-top-color: $statusCreated !important;
				}
				&.READY {
					border-top-color: $statusReady !important;
				}
				&.EDITED {
					border-top-color: $statusEdited !important;
				}
				&.LAYOUTED {
					border-top-color: $statusLayouted !important;
				}
				&.REVISED {
					border-top-color: $statusRevised !important;
				}
				&.APPROVED {
					border-top-color: $statusApproved !important;
				}
				&.PRINT_APPROVED {
					border-top-color: $statusPrintApproved !important;
				}
				&.REVIEW {
					border-top-color: $statusReview !important;
				}
			}
		}

	}

	.variantStatus-DEFAULT {
		background: $variantStatusDefault !important;
	}
	.variantStatus-SELECTED {
		background: $variantStatusSelected !important;
	}
	.variantStatus-APPROVED {
		background: $variantStatusApproved !important;
	}


	.option__statusIndicator.CREATED {
		background: $statusCreated !important;
	}
	.option__statusIndicator.READY {
		background: $statusReady !important;
	}
	.option__statusIndicator.EDITED {
		background: $statusEdited !important;
	}
	.option__statusIndicator.LAYOUTED {
		background: $statusLayouted !important;
	}
	.option__statusIndicator.REVISED {
		background: $statusRevised !important;
	}
	.option__statusIndicator.APPROVED {
		background: $statusApproved !important;
	}
	.option__statusIndicator.PRINT_APPROVED {
		background: $statusPrintApproved !important;
	}
	.option__statusIndicator.REVIEW {
		background: $statusReview !important;
	}

	.section {
		padding: 25px;
		margin-top: 25px;
		background: #fff;

		.title {
			text-transform: uppercase;
		}
	}

	.variants {

		.notification {
			margin: 0 auto;
			max-width: 640px;
		}

		.column:first-child {
			border-right: 1px solid #DDD;
		}

		.variant {
			width: 100%;
			max-width: 640px;
			height: 280px;
			background-color: #FAFAFA;
			border-radius: 2px;
			margin: 0 auto 25px auto;

			.variantImgWrapper {
				display: block;
				height: 87%;
				width: 100%;
				padding: 12px 4px;
				.lazyImg {
					background-size: contain;
					background-position: center;
					background-repeat: no-repeat;
					width: 100%;
					height: 100%;
					cursor: -moz-zoom-in;
					cursor: -webkit-zoom-in;
					cursor: zoom-in;
				}
			}

			.variantOptions {
				border-top: 1px solid #ddd;
				background: #fcfcfc;
				padding: 6px 8px;
				border-bottom-left-radius: 2px;
				border-bottom-right-radius: 2px;
			}

		}

	}


	.columns.pageSettings {
		width: 100%;
		padding: 16px 0 24px 0;
		margin: 0;
			.column.left {
				border-right: 1px solid #aaa;
				.control.is-horizontal {
					justify-content: end;
				}
		}
		.column.right {
			.control.is-horizontal {
				justify-content: start;
				.control-label {
					order: 2;
					label {
						margin: 0 auto 0 12px;
					}
				}
			}
		}
	}
/*
.variantWrapper {
	background: #fafafa;
	border: 1px solid #eee;
	border-radius: 4px;
}
/*
.variantImageWrapper {
	text-align: center;
	height: 11.1vw;
	cursor: pointer;
}

.variantImageWrapper .lazyImg {
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	width: 100%;
	height: 100%;
	cursor: -moz-zoom-in;
	cursor: -webkit-zoom-in;
	cursor: zoom-in;
}
.variantOptions {
	border-top: 1px solid #ddd;
	background: #fcfcfc;
	padding: 8px 10px;
}
*/
</style>


<style scoped>
	.control.multiselect {
		width: 50%;
		margin: 0 auto;
	}

	.col-main {
		margin-bottom: 40px;
	}
	#pagesWrapper {
		background: #fff;
		/*
		padding: 30px;
		margin: 20px 0 0 0;
		*/
		margin: 0;
		padding: 0 12px 12px 12px;
		min-width: 700px;
	}

	.pageOptions {
		max-width: 1300px;
		margin: 0 auto !important;
		text-align: center !important;
	}


</style>
